import * as entityActions from 'client/actions/entityActions'
import DropBoxEmpty from 'client/components/core/ChildrenEntities/components/drop-box-empty'
import DropBoxEntity from 'client/components/core/ChildrenEntities/components/drop-box-entity'
import { useCreateEntityElement } from 'client/context/CreateEntityContext'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { createEmptyEntityElement } from 'client/pages/createCommonEntityElement'
import { getChildrenEntities } from 'client/reducers/pageReducer'
import { getAllowedTypes } from 'client/utils/validators'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { useActions } from 'common/hooks/useActions'
import React, { memo, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { isVisible } from 'tools/utils/entityUtils'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

export interface ChildrenEntitiesProps {
  id: EntityIdType
  type: EntityTypeEnum
  childIds?: string[]
  placeholderText?: string | null
  expandedDropZone?: boolean
  isReadOnly?: boolean | undefined
}

const ChildrenEntities = ({
  id,
  type,
  childIds = [],
  placeholderText = null,
  expandedDropZone = false,
  isReadOnly,
}: ChildrenEntitiesProps) => {
  const { isDesktop } = useDeviceModeContext()
  const { createEntityElement, excludedEntitiesIds } = useCreateEntityElement()
  const entities = useSelector(
    //@ts-expect-error @TODO ts migration is needed
    state => getChildrenEntities(state.page.present, childIds),
    shallowEqual,
  )
  const [createEntity, moveEntity, createBlock] = useActions([
    entityActions.createIn,
    entityActions.moveNew,
    entityActions.createBlockIn,
  ])
  const allowedTypes = useMemo(() => getAllowedTypes(type), [type])
  const noVisibleEntities = useMemo(
    //@ts-expect-error @TODO ts migration is needed
    () => entities.every(entity => !isVisible(entity, isDesktop)),
    [isDesktop, entities],
  )

  if (isReadOnly) {
    //@ts-expect-error @TODO ts migration is needed
    return entities.map(entity =>
      excludedEntitiesIds.includes(entity.id)
        ? //@ts-expect-error @TODO ts migration is needed
          createEmptyEntityElement(entity)
        : createEntityElement(entity),
    )
  }

  if (noVisibleEntities) {
    return (
      <DropBoxEmpty
        type={type}
        placeholderText={placeholderText}
        parentId={id}
        allowedTypes={allowedTypes}
        createEntity={createEntity}
        createBlock={createBlock}
        moveEntity={moveEntity}
      />
    )
  }

  //@ts-expect-error @TODO ts migration is needed
  return entities.map((entity, index) => {
    if (excludedEntitiesIds.includes(entity.id)) {
      return <div />
    }
    return (
      <DropBoxEntity
        key={entity.id}
        position={index}
        parentId={id}
        //@ts-expect-error @TODO ts migration is needed
        allowedTypes={allowedTypes}
        createEntity={createEntity}
        createBlock={createBlock}
        moveEntity={moveEntity}
        expanded={expandedDropZone}
      >
        {/* @ts-expect-error @TODO ts migration is needed */}
        {createEntityElement(entity, {
          isMoveDownAllowed:
            entities.length > 1 && entities.length !== index + 1,
          isMoveUpAllowed: entities.length > 1 && index !== 0,
        })}
      </DropBoxEntity>
    )
  })
}

export default memo(ChildrenEntities)
